<template>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">
              {{ form.id ? 'Update Voter' : 'Create New Voter' }}
            </h4>
          </div>
          <div class="card-body">
            <div class="row">
             
              <div class="col-md-4">
                <div class="form-group">
              <label>Comelec ID</label>
              <ValidationProvider name="comelec_id" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Comelec ID is required' : null" :hasSuccess="passed"
                  name="name" v-model="form.comelec_id">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
              <label>Precint Number</label>
              <ValidationProvider name="precint_number" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Precint number is required' : null" :hasSuccess="passed"
                  name="precint_number" v-model="form.precint_number">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
              <label>Purok</label>
              <ValidationProvider name="purok" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Purok is required' : null" :hasSuccess="passed"
                  name="last_name" v-model="form.purok">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
              <label>First Name</label>
              <ValidationProvider name="first_name" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'First name is required' : null" :hasSuccess="passed"
                  name="name" v-model="form.first_name">
                </fg-input>
              </ValidationProvider>
            </div>
            
          
              </div>
              <div class="col-md-4">
                <div class="form-group">
              <label>Middle Name</label>
              <ValidationProvider name="middle_name" rules="" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Middle name is required' : null" :hasSuccess="passed"
                  name="middle_name" v-model="form.middle_name">
                </fg-input>
              </ValidationProvider>
            </div>

              </div>
              <div class="col-md-4">
                <div class="form-group">
              <label>Last Name</label>
              <ValidationProvider name="last_name" rules="required" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Last name is required' : null" :hasSuccess="passed"
                  name="last_name" v-model="form.last_name">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
              <label>Full Address</label>
              <ValidationProvider name="full_address" rules="" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? ' is required' : null" :hasSuccess="passed"
                  name="last_name" v-model="form.full_address">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>
              
              <div class="col-md-4">
                <div class="form-group">
          <label>Birth Date</label>
          <ValidationProvider name="birthdate" rules="required" v-slot="{ passed, failed }">
            <el-date-picker v-model="form.birth_date" type="date" placeholder="Pick a day" class="form-group" :class="[
                  { 'has-danger': failed },
                  { 'has-success': passed }]">
            </el-date-picker>
            <br><span class="error-text" v-if="failed">Birth date is required</span>
          </ValidationProvider>
        </div>
              </div>
             
            

              <div class="col-md-4">
                <div class="form-group">
              <label>Contact Number</label>
              <ValidationProvider name="purok" rules="=" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Purok is required' : null" :hasSuccess="passed"
                  name="last_name" v-model="form.contact_number">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
              <label>Email</label>
              <ValidationProvider name="purok" rules="" v-slot="{ passed, failed }">
                <fg-input type="text" :error="failed ? 'Purok is required' : null" :hasSuccess="passed"
                  name="last_name" v-model="form.email">
                </fg-input>
              </ValidationProvider>
            </div>
              </div>
            </div>
            
            
            

            
           
          </div>
          <div class="card-footer text-right">
            <p-button type="info" native-type="submit">Save</p-button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </template>
  <script>
  import { extend } from "vee-validate";
  import { required } from "vee-validate/dist/rules";
  import { Voter } from '@/resources/voter'

  extend("required", required);
  
  export default {
    props: ['voter'],
    data() {
      return {
        form: {
          code: "",
          name: "",
        },
        loading: false
      };
    },
    watch: {
      voter: function () {
        if (this.voter) this.form = Object.assign({}, this.voter)
      }
    },
    created: function () {
      if (this.voter) this.form = Object.assign({}, this.voter)
    },
    beforeDestroy() {
      this.form = {
        code: "",
        name: "",
      }
    },
    methods: {
      submit() {  
        this.loading = true
        this.form.birth_date = this.$moment(this.form.birth_date).format('YYYY-MM-DD')
        let request = this.form.id ? Voter.update(this.form.id, this.form) : Voter.create(this.form)
  
        request
          .then(result => {
            this.$notify({
              type: 'success',
              title: "Success",
              text: 'Voter has been saved',
            });
            this.$emit('save', true)
          })
          .catch(error => {
        
          }).finally(() => {
            this.loading = false
          })
      }
    }
  }
  </script>
  <style></style>
  